<!--凝血功能-->
<script setup>
import { computed, reactive,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"
import check from "./check.vue";

import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
     <div style="display:flex;">
      <h2>凝血功能</h2>
      <upload :type="props.type" :data="model" name="nxgn"></upload>
      <check :period="props.type" text="凝血功能" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="凝血功能是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['凝血功能是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['凝血功能是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增凝血功能':'凝血功能'"  v-if="crfFields && notScreen" class="redStar">
            <el-radio-group v-if="notScreen" v-model="crfFields['是否新增凝血功能']">
              <el-radio label="是" prop="是"></el-radio>
              <el-radio label="否" prop="否"></el-radio>
            </el-radio-group>

        </el-form-item>
        
        <template v-if="crfFields['是否新增凝血功能'] == '是' || !notScreen">
            <el-form-item label="INR" class="redStar" :prop="itemProp(`INR`)" :rules="crfStore.textRules(`INR`,true)">
              <el-input v-model="crfFields['INR']" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="D-二聚体（ug/m）" class="redStar" :prop="itemProp(`D-二聚体`)" :rules="crfStore.textRules(`D-二聚体`,true)">
              <el-input v-model="crfFields['D-二聚体']" autocomplete="off">
                <template #append>ug/m</template>
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="PTA（%）" class="redStar">
              <el-input v-model="crfFields['PTA']" autocomplete="off">
                <template #append>%</template>
              </el-input>
            </el-form-item> -->
            <el-form-item label="凝血酶原时间（s）" class="redStar" :prop="itemProp(`凝血酶原时间`)" :rules="crfStore.textRules(`凝血酶原时间`,true)">
              <el-input v-model="crfFields['凝血酶原时间']" autocomplete="off">
                <template #append>s</template>
              </el-input>
            </el-form-item>

            <el-form-item label="纤维蛋白原（g/L）" class="redStar" :prop="itemProp(`纤维蛋白原（g/L）`)" :rules="crfStore.textRules(`纤维蛋白原（g/L）`,true)">
              <el-input v-model="crfFields['纤维蛋白原（g/L）']" autocomplete="off">
                <template #append>g/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="血栓弹力图（可选）" class="not_redStar">
              <upload :type="props.type" :data="model" name="nxgn_xstlt" btn_name="图片上传"></upload>
            </el-form-item>
        </template>
      </template>
  </template>
</template>

<style lang="scss" scoped>
  ::v-deep .btn_fiexd {
    margin-left: 0;
    margin-top: 0;
}
</style>